// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"3724":"VoltoFormBlockEdit","4328":"Widgets","5240":"volto-dropdownmenu-manage","5772":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] || chunkId) + "." + {"1668":"01997a81","3724":"63b7cf60","4328":"5b14901f","5240":"f0610ba2","5772":"1e7870a9"}[chunkId] + ".chunk.css";
};